'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';


TaskMetricsService.$inject = [
  '$exceptionHandler',
  '$cacheFactory',
  '$timeout',
  '$domain',
];

const CACHE_ID = 'TaskMetricsService';

export function TaskMetricsService(
  $exceptionHandler,
  $cacheFactory,
  $timeout,
  $domain,
) {
  const metricsCache = $cacheFactory.get(CACHE_ID) || $cacheFactory(CACHE_ID);

  // Export normal named 'exports'
  bindMetricsToScope.bindMetricsToScope = bindMetricsToScope;
  bindMetricsToScope.getMetrics$ = getMetrics$;

  // Export default
  return bindMetricsToScope;

  function bindMetricsToScope(scope, model, onUpdate, useTimeout) {
    const modelId = getId(model);
    const cachedMetrics = metricsCache.get(modelId);

    if (cachedMetrics) {
      onUpdate(cachedMetrics);
    }

    if (useTimeout) {
      const to = $timeout(buildObserver.bind(null, scope, onUpdate, model, modelId), useTimeout);

      scope.$on('$destroy', $timeout.cancel.bind($timeout, to));
    } else {
      buildObserver(scope, onUpdate, model, modelId);
    }
  }

  function buildObserver(scope, onUpdate, model, modelId) {
    const ref = model.$getMetricsRef();
    ref.on('value', _onMetricsUpdate, _onErrorMetrics);

    scope.$on('$destroy', _cleanup);

    function _onMetricsUpdate(ss) {
      const metrics = ss.val();
      metricsCache.put(modelId, metrics);
      onUpdate(metrics);
    }

    function _onErrorMetrics(error) {
      if (error.code === "PERMISSION_DENIED") {
        // task is no longer available. ignore the error
      } else {
        $exceptionHandler(error, 'TaskCardController.metrics error occurred in metrics observer');
      }
    }

    function _cleanup() {
      ref.off('value', _onMetricsUpdate);
    }
  }

  // RX version

  /**
   * @param {Object} model POJO or AngularDomain instance for any class that implements MetricMixin
   * @param {?Number} [useTimeout=null]
   * @return {Observable<Object>}
   */
  function getMetrics$(model, useTimeout) {
    const modelId = getId(model);
    const modelCollection = getCollection(model);
    const cachedMetrics = metricsCache.get(modelId);

    const metrics$ = useTimeout
      ? Observable.timer(useTimeout)
        .take(1)
        .switchMap(getObserver$.bind(null, modelId, modelCollection))
      : getObserver$(modelId, modelCollection);

    return cachedMetrics
      ? metrics$.startWith(cachedMetrics)
      : metrics$;
  }

  function getObserver$(modelId, modelCollection) {
    const domainClass = $domain.getDomainClass(modelCollection);
    return domainClass
      .$getMetricsRef(modelId)
      .observe('value')
      .map(_onMetricsUpdate)
      .catch(_onErrorMetrics);


    function _onMetricsUpdate(ss) {
      const metrics = ss.val();
      metricsCache.put(modelId, metrics);
      return metrics;
    }

    function _onErrorMetrics(error/* , source$*/) {
      if (error.code === "PERMISSION_DENIED") {
        // task is no longer available. ignore the error
      } else {
        $exceptionHandler(error, 'TaskCardController.metrics error occurred in metrics observer');
      }

      return Observable.of(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/services/TaskMetricsService.js